var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 65,
    viewBox: "0 0 84 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1234 8.7675L79.7915 5.43555L48.9272 36.2999C45.0692 40.1579 38.5806 40.1579 34.7226 36.2999L3.85831 5.61092L0.526367 8.94285L23.4992 31.9157L0.526367 54.8886L3.85831 58.2205L26.8312 35.2477L31.3907 39.8072C34.1965 42.613 37.8792 44.1913 41.7372 44.1913C45.5953 44.1913 49.2779 42.613 52.0838 39.8072L56.6433 35.2477L79.6161 58.2205L82.9481 54.8886L59.9752 31.9157L83.1234 8.7675Z",
    fill: "#8052D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6347 64.1837H7.36535C3.33195 64.1837 0 60.8518 0 56.8184V7.36534C0 3.33194 3.33195 0 7.36535 0H76.6347C80.6681 0 84 3.33194 84 7.36534V56.8184C84 60.8518 80.6681 64.1837 76.6347 64.1837ZM7.18998 4.73486C5.78705 4.73486 4.73487 5.78704 4.73487 7.18996V56.643C4.73487 58.0459 5.78705 59.0981 7.18998 59.0981H76.4593C77.8622 59.0981 78.9144 58.0459 78.9144 56.643V7.18996C78.9144 5.78704 77.8622 4.73486 76.4593 4.73486H7.18998Z",
    fill: "#8052D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLight);
export default __webpack_public_path__ + "static/media/email-light.2af05865.svg";
export { ForwardRef as ReactComponent };